/* eslint-disable no-use-before-define */
import React from 'react'
import { Fields, openWindow, } from '../../twd/twd'
import { useOrderTicket } from '../use-order-ticket'


export const Attestation = () => {

    const { hasAttestCD, attestCD, setAttestCD, hasAttestCorp, attestCorp, setAttestCorp, bondInfo } = useOrderTicket()

    const prospectus = bondInfo && bondInfo.issue && bondInfo.issue.prospectus

    return <React.Fragment>
        {hasAttestCD && <div className="row vertical-offset-xs" >
        <div className="col-md-12 col-xs-12">
            <div style={GreyBackground}>
            <div className="vertical-offset-xs">You must acknowledge
                the <a href='#'
                    style={{cursor:'pointer', textDecoration:'underline'}}
                    onClick={() => openWindow("https://us.etrade.com/l/f/agreement-library/brokered-cd-disclosure", '_blank')}
                >Brokerage CD Disclosure</a> before placing this order.
            </div>
            <Fields.CheckboxLabel
                label="I have accessed the Brokerage CD Disclosure and agree to its terms."
                checked={attestCD}
                onChange={() => setAttestCD(!attestCD)}
            />
            </div>
        </div>
        </div>}

        {hasAttestCorp && prospectus && <div className="row vertical-offset-xs">
            <div className="col-md-12 col-xs-12" >
                <div style={GreyBackground}>
                <div className="vertical-offset-xs">You must acknowledge
                    the <a href='#'
                        style={{cursor:'pointer', textDecoration:'underline'}}
                        onClick={() => openWindow(prospectus, '_blank')}
                    >prospectus / offering document</a> before placing this order.
                </div>

                <Fields.CheckboxLabel
                    label="I have reviewed the prospectus / offering document before placing this order."
                    checkboxStyle={{}}
                    style={{width:'100%'}}
                    checked={attestCorp}
                    onChange={() => setAttestCorp(!attestCorp)}
                    />
                </div>
            </div>
            </div>
        }
    </React.Fragment>
}


const GreyBackground = {
    padding: '10px',
    backgroundColor:"rgb(246, 246, 246)"
}



// WEBPACK FOOTER //
// ./src/order-ticket/form/attestations.js